import { instance as axiosToken, setJwtToken } from "../config/axiosInstance";
import { instance as axios } from "../config/axiosInstance";
// ------------------------- Login -------------------------
export const sendOtpApi = async (data) => {
  return await axios.post(`user/auth/send-otp`, data);
};

// --------------------verify-Otp-Api--------------------
export const verifyOtpApi = async (data) => {
  return await axios.post(`user/auth/verify-otp`, data);
};
// ------------------------- Login -------------------------
export const reSendOtpApi = async (data) => {
  return await axios.post(`user/auth/resend-otp`, data);
};
// ---------------------logout-Api---------------------
export const logoutApi = async (data) => {
  return await axios.post(`user/auth/logout`, data);
};
